export const mapToCssModules = (cssModule = []) => {
    if (!cssModule)
        return cssModule;
    return cssModule
        .filter((className) => !!className)
        .join(' ');
};
//# sourceMappingURL=className.js.map